import React, { ChangeEvent, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { FormControl, InputLabel, Select, MenuItem, Tooltip, Zoom } from '@material-ui/core';
import { Button, Container, Typography, List, ListItem, Dialog, DialogTitle, DialogContent, DialogActions, TextField, Modal } from '@material-ui/core';
import { connect, ConnectedProps } from 'react-redux';
import store from './../redux/store';
//import { usuario } from '../redux/carrerGuide/actions';
import { fetchEmpresas } from '../redux/empresas/actions';
import { useNavigate } from 'react-router-dom';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import AddIcon from '@material-ui/icons/Add';
import ViewHeadline from '@material-ui/icons/ViewHeadline';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { InputAdornment } from '@material-ui/core';
import { Email, Phone, Business, ImageSearch, FileCopy } from '@material-ui/icons';
import { getEmpresas } from '../api';
import { green } from '@material-ui/core/colors';
import moment from 'moment'
import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Close';
import Box from '@mui/material/Box';
import {
    useGridApiRef,
    GridRowsProp,
    GridRowModesModel,
    GridRowModes,
    DataGrid,
    GridColDef,
    GridToolbar,
    GridToolbarContainer,
    GridActionsCellItem,
    GridEventListener,
    GridRowId,
    GridRowModel,
    GridRowEditStopReasons,
    GridValueGetterParams,
    GridToolbarExport,
} from '@mui/x-data-grid';
import { Autocomplete, Avatar, Card, CardActions, CardContent, CardHeader, Collapse, Divider, LinearProgress, ListItemButton, ListSubheader, Stack, styled } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import IconButton, { IconButtonProps } from '@mui/material/IconButton';

import dayjs, { Dayjs } from 'dayjs';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

import { DefaultizedPieValueType } from '@mui/x-charts';
import { PieChart, pieArcLabelClasses } from '@mui/x-charts/PieChart';


import { client, AUTH_USER, getUsers, getCarrerguide, filterCategory, whoami, UPDATE_USER, CREATE_CATEGORY, REMOVE_COMPANY, CREATE_COMPANY, getCategories, UPDATE_COMPANY, REMOVE_CATEGORY, UPDATE_CATEGORY, filterCompany, CREATE_CARRERGUIDE, REMOVE_CARRERGUIDE, UPDATE_CARRERGUIDE } from '../graphqlClient/graphql'
import { useMutation } from '@apollo/client';
import Notifications from './../components/notifications/Notifications';
import { UploadFile } from '@mui/icons-material';
import { serverConfig } from './../api/apiConfig';
const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'flex-start',
        height: '100%',
        textAlign: 'center',
        width:'100%'
    },
    container: {
        display: 'flex',
        justifyContent: 'center',
        //alignItems: 'center',
        height: '100%',
    },
    content: {
        width:'100%',
        textAlign: 'center',
    },
    title: {
        marginBottom: theme.spacing(2),
    },
    listItem: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: theme.spacing(1),
    },
    deleteButton: {
        marginLeft: theme.spacing(1),
    },
    addButton: {
        margin: theme.spacing(2),
        backgroundColor: green[500],
        color: 'white',
        '&:hover': {
            backgroundColor: green[700],
        },
    },
    modalContent: {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(2),
    },
    listContainer: {
        //maxWidth:'80%',
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        alignContent: 'flex-start',
        justifyContent: 'center',
        alignItems: 'flex-start',

        maxHeight: 'calc(100vh - 100px)',
        overflow: 'auto',
        '&::-webkit-scrollbar': {
            width: '8px',
        },
        '&::-webkit-scrollbar-track': {
            backgroundColor: '#f1f1f1',
        },
        '&::-webkit-scrollbar-thumb': {
            backgroundColor: 'green',
        },
        '&::-webkit-scrollbar-thumb:hover': {
            backgroundColor: 'darkgreen',
        },
    },
}));

interface ExpandMoreProps extends IconButtonProps {
    expand: boolean;
}

const ExpandMore = styled((props: ExpandMoreProps) => {
    const { expand, ...other } = props;
    return <IconButton {...other} />;
})(({ theme, expand }) => ({
    transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shortest,
    }),
}));

type PropsFromRedux = ConnectedProps<typeof connector>;

const CarrerGuidePage: React.FC<PropsFromRedux> = ({ user }) => {
    const classes = useStyles();
    const itensList = ['Aerospace and Defense', 'Airline Industry', 'Agriculture', 'Automotive', 'Banking and Financial Services', 'Biotechnology', 'Chemicals', 'Construction', 'Consumer Goods', 'Commerce', 'Crypto', 'Education', 'Electronics', 'Energy (Oil & Gas, Renewable Energy)', 'Engineering', 'Entertainment (Film, Music, Gaming)', 'Environmental Services', 'Fashion and Apparel', 'Food and Beverage', 'Forestry and Timber', 'Government and Public Administration', 'Healthcare (Hospitals, Pharmaceuticals)', 'Hospitality and Tourism', 'Insurance', 'Internet and Technology', 'Legal Services', 'Logistics and Transportation', 'Manufacturing', 'Media and Communications', 'Mining and Metals', 'Nonprofit Organizations', 'Personal Care and Cosmetics', 'Real Estate', 'Retail', 'Telecommunications', 'Textiles', 'Travel and Leisure', 'Utilities (Water, Gas, Electricity)', 'Waste Management', 'Advertising and Marketing', 'Aerospace Manufacturing', 'Airline Industry', 'Alternative Energy', 'Amusement Parks and Attractions', 'Architecture and Planning', 'Artificial Intelligence', 'Automotive Manufacturing', 'Aviation', 'Biomedical Devices', 'Broadcasting', 'Business Services', 'Clean Technology', 'Cloud Computing', 'Commercial Real Estate', 'Computer Hardware', 'Computer Software', 'Consulting', 'Defense and Space', 'Dental Services', 'E-commerce', 'Education Management', 'Electrical/Electronic Manufacturing', 'Employment Services', 'Environmental Services', 'Events Services', 'Facilities Services', 'Farming', 'Financial Technology (Fintech)', 'Fishery', 'Fitness and Wellness', 'Gambling and Casinos', 'Glass, Ceramics, and Concrete', 'Health and Wellness', 'Health Insurance', 'Higher Education', 'Human Resources', 'Import and Export', 'Industrial Automation', 'Information Technology and Services', 'Infrastructure', 'Insurance', 'Internet', 'Investment Banking', 'Legal Services', 'Leisure, Travel & Tourism', 'Logistics and Supply Chain', 'Machinery', 'Management Consulting', 'Maritime', 'Medical Devices', 'Mental Health Care', 'Nanotechnology', 'Nuclear Energy', 'Oil & Energy', 'Outsourcing/Offshoring', 'Paper & Forest Products', 'Pharmaceuticals', 'Photography', 'Plastics', 'Public Relations and Communications', 'Renewable & Environment', 'Research', 'Restaurants', 'Startup', 'Sporting Goods', 'Social Media']
    let index = 0;
    const navigate = useNavigate();
    const [CreateCarrerguideMutation, { data }] = useMutation(CREATE_CARRERGUIDE);
    const [UpdateCarrerguideMutation, { data: updateCarrerguideData }] = useMutation(UPDATE_CARRERGUIDE);
    const [RemoveCarrerguideMutation] = useMutation(REMOVE_CARRERGUIDE);
    const [deleteConfirmationOpen, setDeleteConfirmationOpen] = React.useState(false);
    const [selectedCategory, setSelectedCategory] = React.useState('');
    const [addCategoryModalOpen, setAddCategoryModalOpen] = React.useState(false);
    const [newCategory, setNewCategory] = React.useState<any>({});
    const [editData, setEditData] = React.useState<any>({});
    const [categories, setCategories] = React.useState<any>([]);
    const [carrerGuide, setCarrerGuide] = React.useState<any>([]);
    const [companies, setCompanies] = React.useState<any>([]);
    const [editCategoryModalOpen, setEditCategoryModalOpen] = React.useState(false);
    const [isLoadingCategories, setIsLoadingCategories] = React.useState(false);
    const [isLoadingCategoriesByFilter, setIsLoadingCategoriesByFilter] = React.useState(false);
    const [passwordOpen, setPasswordOpen] = React.useState(false);
    const [loading, setLoading] = React.useState(false);
    const permissoesList = ['administrador', 'gerente', 'basico']
    const [rows, setRows] = React.useState(carrerGuide);
    const [rowModesModel, setRowModesModel] = React.useState<GridRowModesModel>({});
    const [save, setSave] = React.useState(false);
    const [selectedUser, setSelectedUser] = React.useState<any>({ key: 0, value: 'Filtro por operador' });

    const [startDate, setStartDate] = React.useState<any>(null);
    const [endDate, setEndDate] = React.useState<any>(null);
    const [file, setFile] = React.useState<File>();
    const [image, setImage] = React.useState<any>('');
    const [openTable, setOpenTable] = React.useState<boolean>(false);
    const [open, setOpen] = React.useState<boolean>(false);
    const [uploadScreen, setUploadScreen] = React.useState<boolean>(false);
    const [imageToOpen, setImageToOpen] = React.useState<any>('');
    const [expanded, setExpanded] = React.useState('');
    const [selected, setSelected] = React.useState('');

    const apiRef = useGridApiRef();

    const handleExpandClick = (id: string) => {
        const newValue = expanded == id ? '' : id
        setExpanded(newValue);
    };

    useEffect(() => {
        console.log('user', user)
        //handleCreateAllCategories()
    }, [user])

    useEffect(() => {
        if (!isLoadingCategories && !isLoadingCategoriesByFilter && carrerGuide.length && openTable) {
            setRows(carrerGuide)
            apiRef.current.setColumnVisibility('_id', false);
        }


    }, [carrerGuide]);
    useEffect(() => {
        if (!isLoadingCategories && openTable && carrerGuide.length) {
            setRows(carrerGuide)
            apiRef.current.setColumnVisibility('_id', false);
        }


    }, [openTable]);

    /* useEffect(() => {
      changeFilter()
      
    }, [selectedUser,startDate, endDate, ]);  */

    /* const handleCreateAllCategories = ()=>{
      const data = {
        createdBy: user._id,
        description: itensList[index],
        name: itensList[index]
      }
      console.log('createCategory',data)
      handleAddCarrerguide(data)
    } */


    const getCategoriesAsync = async () => {

        const result: any = await getCategories()
        console.log('resutl ===>', result)

        if (result?.length) {
            setCategories(result)
        }
    }
    const getCarrerguideAsync = async () => {

        const result: any = await getCarrerguide()
        console.log('resutl ===>', result)

        if (result?.length) {
            setCarrerGuide(result)
        }
    }
    const getCompaniesAsync = async () => {

        const result: any = await getCategories()
        console.log('resutl ===>', result)

        if (result?.length) {
            setCategories(result)
        }
    }

    useEffect(() => {
        getCategoriesAsync();
        getCarrerguideAsync();
    }, []);

    const handleFileChange = (e: ChangeEvent<HTMLInputElement>) => {
        if (e.target.files) {
            setFile(e.target.files[0]);
            setImage(URL.createObjectURL(e.target.files[0]))
        }
    };
    const clearImage = () => {
        setImage('')

    };



    const handleDeleteClick = (id: any) => {
        console.log('id', id)

        setSelectedCategory(id);
        setDeleteConfirmationOpen(true);
    };

    const handleDeleteConfirmation = async () => {
        console.log('selectedCategory', selectedCategory)
        try {

            const id: string = selectedCategory
            console.log('id', id)

            const result = await RemoveCarrerguideMutation({
                variables: {
                    id
                },
                onCompleted: ({ removeCarrerguide }) => {

                    console.log('removeCarrerguide == > ', removeCarrerguide);
                    const notData = {
                        type: 'success',
                        message: `Item removed Successfully!`,
                        title: 'wescout',
                        timeOut: 2500,
                        callback: () => { },
                        priority: true,
                    }
                    getCarrerguideAsync()
                    Notifications(notData)

                    //navigate('/login')
                    //setCategory(updateUser);
                }
            });
        } catch (error: any) {
            const notData = {
                type: 'error',
                message: error.message,
                title: 'wescout',
                timeOut: 2500,
                callback: () => { },
                priority: true,
            }
            Notifications(notData)
            console.log("Erro ao deletar ", error.message)

        }

        setDeleteConfirmationOpen(false);
    };

    const clearNewCategory = () => {
        setNewCategory({})

    }

    const handleAddCarrerguide = async (data?: any) => {

        const dataToSend = data.name ? data : { ...newCategory, createdBy: user._id }
        console.log('dataToSend', dataToSend)
        if (file) {
            console.log(file)
            dataToSend.image = file;
            //dataToSend.contador = (contador+1);
        }
        // dataToSend.id = dataToSend._id
        delete dataToSend.__typename
        console.log('dataToSend', dataToSend)
        if (typeof dataToSend.image == 'string') delete dataToSend.image
        try {

            const createCarrerguideInput = dataToSend
            console.log('createCarrerguideInput', dataToSend)

            const result = await CreateCarrerguideMutation({
                variables: {
                    createCarrerguideInput
                },
                onCompleted: async ({ createCarrerguide }) => {

                    console.log('createCarrerguide == > ', createCarrerguide);
                    const notData = {
                        type: 'success',
                        message: `Carrer guide ${createCarrerguide?.name} Created Successfully!`,
                        title: 'wescout',
                        timeOut: 2500,
                        callback: () => { },
                        priority: true,
                    }
                    await getCarrerguideAsync()
                    Notifications(notData)
                    /*  if(index < itensList.length){
                       index++
                       handleCreateAllCategories()
                     } */
                    //navigate('/login')
                    //setCategory(updateUser);
                }
            });
        } catch (error: any) {
            const notData = {
                type: 'error',
                message: error.message,
                title: 'wescout',
                timeOut: 2500,
                callback: () => { },
                priority: true,
            }
            Notifications(notData)
            console.log("Erro ao criar usuário", error)

        }
        setAddCategoryModalOpen(false);
        clearNewCategory()
    };


    const validateEmail = (email: any) => {
        return true
        // Implemente a lógica de validação do e-mail aqui
    };

    const validateCNPJ = (cnpj: any) => {
        // Remove caracteres não numéricos
        cnpj = cnpj.replace(/[^\d]+/g, '');

        // Verifica se possui 14 dígitos
        if (cnpj.length !== 14) {
            return false;
        }

        // Verifica se todos os dígitos são iguais (ex: 00000000000000)
        if (/^(\d)\1+$/.test(cnpj)) {
            return false;
        }

        // Validação do primeiro dígito verificador
        let sum = 0;
        let factor = 5;
        for (let i = 0; i < 12; i++) {
            sum += parseInt(cnpj[i]) * factor;
            factor = factor === 2 ? 9 : factor - 1;
        }

        let digit = sum % 11 < 2 ? 0 : 11 - (sum % 11);
        if (parseInt(cnpj[12]) !== digit) {
            return false;
        }

        // Validação do segundo dígito verificador
        sum = 0;
        factor = 6;
        for (let i = 0; i < 13; i++) {
            sum += parseInt(cnpj[i]) * factor;
            factor = factor === 2 ? 9 : factor - 1;
        }

        digit = sum % 11 < 2 ? 0 : 11 - (sum % 11);
        if (parseInt(cnpj[13]) !== digit) {
            return false;
        }

        return true;
    };


    const maskCNPJ = (cnpj: any) => {
        // Remove caracteres não numéricos
        cnpj = cnpj.replace(/[^\d]+/g, '');

        // Aplica a máscara
        cnpj = cnpj.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');

        return cnpj;
    };

    const validatePhone = (phone: any) => {
        // Remove caracteres não numéricos
        phone = phone.replace(/[^\d]+/g, '');

        // Verifica se possui 11 dígitos (considerando o DDD)
        if (phone.length !== 11) {
            return false;
        }

        // Verifica se todos os dígitos são iguais (ex: 00000000000)
        if (/^(\d)\1+$/.test(phone)) {
            return false;
        }

        return true;
    };

    const maskPhone = (phone: any) => {
        // Remove caracteres não numéricos
        phone = phone.replace(/[^\d]+/g, '');

        // Aplica a máscara
        phone = phone.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');

        return phone;
    };

    const handleEditCategory = (data: any) => {
        console.log('data selecionada ==>> ', data)
        setEditData(data);
        setEditCategoryModalOpen(true);
    };

    const handleUpdateCategory = async (data?: any) => {

        let dataToSend = { ...editData }
        if (!dataToSend._id) dataToSend = { ...data }
        console.log('dataToSend handleUpdateCategory', dataToSend)

        if (file) {
            console.log(file)
            dataToSend.image = file;
            //dataToSend.contador = (contador+1);
        }

        if (dataToSend.__typename) delete dataToSend.__typename;
        if (dataToSend.createdAt) delete dataToSend.createdAt;
        if (dataToSend.isNew) delete dataToSend.isNew;
        if (dataToSend.createdBy) delete dataToSend.createdBy
        if (typeof dataToSend.image == 'string') delete dataToSend.image
        try {

            const updateCategoryInput = { ...dataToSend }
            console.log('updateCategoryInput', updateCategoryInput)

            const result = await UpdateCarrerguideMutation({
                variables: {
                    updateCategoryInput
                },
                onCompleted: ({ updateCategory }) => {

                    console.log('company updated== > ', updateCategory);
                    const notData = {
                        type: 'success',
                        message: `Category ${updateCategory?.name} Updated Successfully!`,
                        title: 'wescout',
                        timeOut: 2500,
                        callback: () => { },
                        priority: true,
                    }
                    setEditData({});
                    setEditCategoryModalOpen(false);
                    getCategoriesAsync()
                    Notifications(notData)

                    //navigate('/login')
                    //setCategory(updateUser);
                }
            });
        } catch (error: any) {
            const notData = {
                type: 'error',
                message: error.message,
                title: 'wescout',
                timeOut: 2500,
                callback: () => { },
                priority: true,
            }
            Notifications(notData)
            console.log("Erro ao criar usuário", error)

        }

        //clearNewCategory()
        //updateCategory(dataToSend)
        setEditData({});
        setEditCategoryModalOpen(false);
        // Lógica para atualizar a Category com os dados do modal
    };

    const validatePassword = (password: string | any[]) => {
        return password.length >= 6;
    };

    const validateConfirmPassword = (password: any, confirmPassword: any) => {
        return password === confirmPassword;
    };



    //init DataGrid dependencies

    const clearData = (d: any) => {
        const dateTransform = (moment(d).format('DD-MM-YYYY h:m'));
        return dateTransform
    }

    const handleRowEditStop: GridEventListener<'rowEditStop'> = (params, event) => {
        if (params.reason === GridRowEditStopReasons.rowFocusOut) {
            event.defaultMuiPrevented = true;
        }
    };

    const handleEditClick = (id: GridRowId) => () => {
        setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.Edit } });
    };

    interface EditToolbarProps {
        setRows: (newRows: (oldRows: GridRowsProp) => GridRowsProp) => void;
        setRowModesModel: (
            newModel: (oldModel: GridRowModesModel) => GridRowModesModel,
        ) => void;
    }

    const _ = (id: GridRowId) => () => {
        setRows(rows.filter((row: any) => row._id !== id));
    };

    const handleCancelClick = (id: GridRowId) => () => {
        setRowModesModel({
            ...rowModesModel,
            [id]: { mode: GridRowModes.View, ignoreModifications: true },
        });

        const editedRow = rows.find((row: any) => row._id === id);
        if (editedRow!.isNew) {
            setRows(rows.filter((row: any) => row._id !== id));
        }
    };

    const processRowUpdate: any = (newRow: GridRowModel) => {
        const updatedRow = { ...newRow, isNew: false };
        console.log('newRow', newRow)
        if (newRow.isNew) {
            delete newRow.isNew
        }
        setEditData(newRow)
        setRows(rows.map((row: any) => (row._id === newRow._id ? updatedRow : row)));
        handleUpdateCategory(newRow)
        return updatedRow;
    };

    const handleRowModesModelChange = (newRowModesModel: GridRowModesModel) => {
        setRowModesModel(newRowModesModel);
    };

    const handleClickImage = () => {
        setOpen((previousOpen) => !previousOpen);
    }

    const ImageComponent = (obj: any) => {
        console.log(obj)
        //setEditReferenciaData(obj.obj.row)
        if (obj.obj.image) {
            const imagePath = serverConfig.dev.url + 'images/' + obj.obj.image;
            return (
                <div style={{ alignSelf: 'center', margin: "0 auto" }} onClick={() => {
                    //console.log(imagePath)
                    setImageToOpen(imagePath)
                    console.log(imageToOpen)
                    handleClickImage()
                }}>
                    <img style={{ objectFit: 'cover' }} height={53} src={imagePath} />
                </div>

            )
        } else {
            return (
                <IconButton onClick={
                    () => {
                        setEditData(obj.obj)
                        setUploadScreen(true)

                        //handleEditReferencia(obj.obj.row)
                    }
                }>
                    <ImageSearch />
                </IconButton>
            )
        }

    }


    const handleSaveClick = (id: GridRowId) => () => {
        const el = rows.filter((item: any) => item._id == id)
        console.log('handleSaveClick', id)
        console.log('handleSaveClick el', el)
        setSave(true)
        setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.View } });
    };
    const handleShowCompanies = (id: any) => () => {
        const el = rows.filter((item: any) => item._id == id)
        setSelectedCategory(id)
        filterCompanyByCategory(id)
    };


    const columns: GridColDef[] = [
        { field: '_id', headerName: 'ID', width: 90 },
        /* {
          field: 'imagem',
          headerName: 'Imagem',
          width: 80,
          editable: false,
          renderCell: (params) => <ImageComponent obj={params.row} />, // renderCell will render the component
        }, */
        {
            field: 'createdAt',
            headerName: 'Date',
            type: 'Date',
            width: 140,
            editable: false,
            valueGetter: (params: GridValueGetterParams) => clearData(params.row.createdAt)
        },
        {
            field: 'name',
            headerName: 'Name',
            width: 150,
            editable: true,
            //valueGetter : (params: GridValueGetterParams)=> getCategoriaNome(params.row.categoria)
        },
        {
            field: 'description',
            headerName: 'Description',
            width: 150,
            editable: true,
            //valueGetter : (params: GridValueGetterParams)=> getCategoriaNome(params.row.categoria)
        },
        /* {
          field: 'email',
          headerName: 'E-mail',
          width: 150,
          editable: true,
          //valueGetter : (params: GridValueGetterParams)=> getCategoriaNome(params.row.categoria)
        }, */
        {
            field: 'createdBy',
            headerName: 'Created by',
            width: 120,
            editable: false,
            valueGetter: (params: GridValueGetterParams) => params.row.createdBy.name || ''
        },



        /* {
          field: 'identificacao',
          headerName: 'código',
          description: 'código do item',
          sortable: false,
          width: 140,
          valueGetter: (params: GridValueGetterParams) =>
            `${params.row.identificacao[0].codigo || ''}  `,
        }, 
        {
          field: 'updatedAt',
          headerName: 'tipo identificacao',
          description: 'tipo de identificacao',
          sortable: false,
          width: 75,
          valueGetter: (params: GridValueGetterParams) =>
            `${params.row.identificacao[0].tipo || ''} `,
        }, */
        {
            field: 'actions',
            type: 'actions',
            headerName: 'Actions',
            width: 150,
            cellClassName: 'actions',
            getActions: ({ id }) => {
                const isInEditMode = rowModesModel[id]?.mode === GridRowModes.Edit;
                const cat = carrerGuide.filter((item: any) => item._id == id)[0]
                if (isInEditMode) {
                    return [
                        <GridActionsCellItem
                            icon={<SaveIcon />}
                            label="Save"
                            sx={{
                                color: 'primary.main',
                            }}
                            onClick={handleSaveClick(id)}
                        />,
                        <GridActionsCellItem
                            icon={<CancelIcon />}
                            label="Cancel"
                            className="textPrimary"
                            onClick={handleCancelClick(id)}
                            color="inherit"
                        />,
                    ];
                }
                return [


                    <GridActionsCellItem
                        icon={<EditIcon />}
                        label="Edit"
                        className="textPrimary"
                        onClick={handleEditClick(id)}
                        color="inherit"
                    />,

                    <GridActionsCellItem
                        icon={
                            <Tooltip TransitionComponent={Zoom} title="Delete" arrow>
                                <IconButton size='small' className='iconDetail' color="primary" aria-label="Editar" >
                                    <DeleteIcon />
                                </IconButton>
                            </Tooltip>
                        }
                        label="Delete"
                        onClick={() => {
                            handleDeleteClick(id)
                        }}
                        color="inherit"
                    />,

                ];
            },
        },


    ];

    const hiddenFields = ['_id', 'id', 'ID'];

    const getTogglableColumns = (columns: GridColDef[]) => {
        console.log('getTogglableColumns', columns)
        return columns
            .filter((column) => !hiddenFields.includes(column.field))
            .map((column) => column.field);
    };

    const changeFilter = async () => {

        const objToSend = {
            startDate,
            endDate,
            //empresa:empresa
            // categoria:selectedCategory?._id || '',
            //usuario : selectedUser?._id || '',

        }
        console.log('objToSend', objToSend)
        const result = await filterCategory(objToSend)
        console.log('result ==>>', result)
        //getProductsByFilter(objToSend)
        //getCategoriesByFilter(objToSend)
        setCategories(result)

    }

    const filterCompanyByCategory = async (catId: any) => {

        const objToSend = {
            //startDate,
            //endDate,
            //empresa:empresa
            category: catId,
            //usuario : selectedUser?._id || '',

        }
        console.log('objToSend', objToSend)
        const result = await filterCompany(objToSend)
        console.log('result companies==>>', result)
        //getProductsByFilter(objToSend)
        //getCompaniesByFilter(objToSend)
        setCompanies(result)

    }

    return (
        <Container className={classes.container}>
            <Modal onClick={(evt) => {
                setImageToOpen('')
                handleClickImage()
            }} open={open} style={{
                width: '100%', textAlign: 'center', display: 'flex',
                alignItems: 'center', justifyContent: 'space-between', backgroundColor: 'white'
            }}>
                <Box>
                    <Typography>
                        close
                    </Typography>
                    <Typography>
                        {/* {editProdutoData.referencia?.nome} */}
                    </Typography>
                    <img width={500} style={{ border: '2px solid white', maxHeight: '80vh' }}
                        src={`${imageToOpen}?w=248&fit=crop&auto=format`}
                        srcSet={`${imageToOpen}?w=248&fit=crop&auto=format&dpr=2 2x`}
                        alt={''}
                        loading="lazy"
                    />
                </Box>


            </Modal>
            <div className={classes.root}>
                <div className={classes.content}>
                    {/* <Button className='backbutton' onClick={() => navigate(-1)}>Go Back</Button> */}
                    <Typography variant="h4" className={'title'}>
                        Carrer Guide ({carrerGuide.length})
                    </Typography>
                    {loading ? (
                        <Box sx={{ width: '100%' }}>
                            <LinearProgress />
                        </Box>
                    ) : null}


                    {

                        user.role == "admin" ? (
                            <>
                                <Button className={classes.addButton} variant="contained" color="primary" startIcon={<AddIcon />} onClick={() => setAddCategoryModalOpen(true)}>
                                    add
                                </Button>
                                {
                                    openTable ? (
                                        <Button className={classes.addButton} variant="contained" color="primary" startIcon={<AddIcon />} onClick={() => setOpenTable(false)}>
                                            hide admin table
                                        </Button>

                                    ) : (
                                        <Button className={classes.addButton} variant="contained" color="primary" startIcon={<AddIcon />} onClick={() => setOpenTable(true)}>
                                            show admin table
                                        </Button>

                                    )
                                }
                            </>
                        ) : null
                    }



                    <Box sx={{ width: '100%', height: 100, }} style={{ alignSelf: 'center', paddingTop: 10, paddingBottom: 10, borderColor: 'green', borderWidth: 2 }}>
                        <Stack borderRadius={15} spacing={2} direction="column" alignItems={'center'} alignContent={'center'} divider={<Divider orientation="vertical" flexItem />}>
                            {/* <Box sx={{  width: '100%' }} style={{display: 'flex',flexDirection: 'row',flexWrap: 'nowrap',height:30, alignContent: 'center', justifyContent: 'space-around', alignSelf:'center', paddingTop:10, paddingBottom:10, borderColor:'green', borderWidth:2}}>
                  
                <Autocomplete
                    getOptionLabel={(usu:any) => usu.nome }
                    //getOptionSelected={(option:any, value:any) => option.nome === value.nome }
                    onChange={(event, newValue) => {
                        console.log(newValue)
                        setSelectedUser(newValue)        
                        changeFilter()
                        
                    }}
                    disablePortal
                    id="combo-box-usuario"
                    options={carrerGuide}
                    sx={{ width: 300 }}
                    renderInput={(params:any) => <TextField {...params} label="Operador" />}
                  />
                
                </Box> */}
                            {/*  <Box sx={{ width: '100%' }} style={{ display: 'flex', flexDirection: 'row', flexWrap: 'nowrap', height: 70, alignContent: 'center', justifyContent: 'center', alignSelf: 'center', paddingTop: 10, paddingBottom: 10, borderColor: 'green', borderWidth: 2 }}>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DemoContainer components={['DatePicker', 'DatePicker']}>
                                        <DatePicker label="Inicial"
                                           
                                            format="DD/MM/YYYY"
                                            onChange={(value: any) => {
                                                if (!value) return
                                                console.log('inicial', value.$d)
                                                setStartDate(value.$d)
                                            }}
                                        />
                                        <DatePicker label="Final"
                                            format="DD/MM/YYYY"
                                            onChange={(value: any) => {
                                                if (!value) return
                                                const valueDate = new Date(value.$d)
                                                valueDate.setHours(23)
                                                valueDate.setMinutes(59)
                                                valueDate.setSeconds(59)
                                                //console.log('day', day)
                                                console.log('final', valueDate)
                                                setEndDate(valueDate)
                                            }}

                                        />
                                    </DemoContainer>
                                </LocalizationProvider>
                                <Button className='{classes.irButton}' onClick={() => changeFilter()}>Ir</Button>
                            </Box> */}
                        </Stack>
                    </Box>
                    {
                        carrerGuide.length && !openTable ? (
                            <div className={classes.listContainer}>

                                {carrerGuide.map((item: any, index: any) => {
                                    
                                
                                        if (expanded==''||expanded==item.name) {
                                            return (<Card sx={{ width: item.name==expanded?'100%':345}} >
                                        
                                                <CardHeader
                                                    avatar={
                                                        <Avatar sx={{ bgcolor: '#0df228' }} aria-label="recipe">
                                                            {item.name.substring(0, 2)}
                                                        </Avatar>
                                                    }
                                                    /* action={
                                                        <IconButton aria-label="settings">
                                                            <MoreVertIcon />
                                                        </IconButton>
                                                    } */
                                                    title={item.name}
                                                    subheader={item.name}
                                                />
                                               
                                                <CardContent >
                                                    {/* <Typography variant="body2">
                                                        {item.description}
                                                    </Typography> */}
                                                    <TextField
                                                                          style={{ marginBottom: 5, maxWidth:item.name==expanded?'90%':345, height:item.name==expanded?300:148 }}
                                                                          variant="outlined"
                                                                          hiddenLabel
                                                                          //label="type a word of interest to you"
                                                                          contentEditable={false}
                                                                          maxRows={item.name==expanded?12:6}
                                                                          multiline
                                                                          value={item.description}
                                                                          onChange={(e) => {
                                                                            //setSelectedKeywords(e.target.value)
                                                                          
                                                                            }}
                                                                            
                                                                        />
                                                </CardContent>
                                                <CardActions disableSpacing>
                                                    <IconButton onClick={() => {
                                                        const notData = {
                                                            type: 'success',
                                                            message: `Description copied to clipboard`,
                                                            title: 'wescout',
                                                            timeOut: 2500,
                                                            callback: () => { },
                                                            priority: true,
                                                        }
        
        
                                                        navigator.clipboard.writeText(item.description)
                                                        Notifications(notData)
                                                    }} aria-label="copy to clipboard">
                                                        <FileCopy />
                                                    </IconButton>
        
                                                    <ExpandMore
                                                        expand={expanded == item.name ? true : false}
                                                        onClick={() => { handleExpandClick(item.name) }}
                                                        aria-expanded={expanded == item.name}
                                                        aria-label="show more"
                                                    >
                                                        <ExpandMoreIcon />
                                                    </ExpandMore>
                                                </CardActions>
                                                {/* <Collapse in={expanded == item.name} timeout="auto" unmountOnExit>
                                                    <CardContent>
                                                        <Typography className='subtitle'>
                                                            {item.description}
                                                        </Typography>
        
                                                    </CardContent>
                                                </Collapse> */}
                                            </Card>)
                                        } 
                                        
                                        
                                        
                                       
                                    
                                    
                                }

                                )}


                            </div>
                        ) : null
                    }
                    {carrerGuide.length && openTable ? (
                        <Box sx={{ width: '100%' }}>

                            <DataGrid
                                apiRef={apiRef}
                                loading={isLoadingCategories || isLoadingCategoriesByFilter}
                                getRowId={(row: { _id: any; }) => row._id}
                                //checkboxSelection
                                disableRowSelectionOnClick

                                onClipboardCopy={(copiedString) => console.log(copiedString)}
                                unstable_ignoreValueFormatterDuringExport
                                autoHeight={true}
                                rows={rows}
                                columns={columns}
                                initialState={{
                                    sorting: {
                                        sortModel: [{ field: 'createdAt', sort: 'asc' }],
                                    },

                                    pagination: {
                                        paginationModel: {
                                            pageSize: 10,
                                        },
                                    },
                                }}
                                pageSizeOptions={[5]}
                                //checkboxSelection

                                //editMode="row"
                                rowModesModel={rowModesModel}
                                onRowModesModelChange={handleRowModesModelChange}
                                onRowEditStop={handleRowEditStop}
                                processRowUpdate={processRowUpdate}
                                // slots={{
                                //   toolbar: EditToolbar,
                                // }}
                                slots={{ toolbar: GridToolbar }}
                                slotProps={{
                                    toolbar: {
                                        setRows, setRowModesModel, csvOptions: {
                                            fileName: 'carrerGuideDataBase_',
                                            delimiter: ';',
                                            utf8WithBom: true,
                                        },
                                        columns: {
                                            columnVisibilityModel: { ID: false, },
                                        },
                                        columnsPanel: {
                                            getTogglableColumns,
                                        },
                                        printOptions: { hideToolbar: true, disableToolbarButton: false }
                                    },
                                }}



                            //toolbar: { printOptions: { getRowsToExport: getSelectedRowsToExport } },


                            />

                        </Box>
                    ) : (<div style={{ margin: 15 }}>

                    </div>)}


                    <Button className='backbutton' onClick={() => navigate(-1)}>Go Back</Button>
                </div>
            </div>

            <Dialog open={deleteConfirmationOpen} onClose={() => setDeleteConfirmationOpen(false)}>
                <DialogTitle>Confirm </DialogTitle>
                <DialogContent>
                    <Typography variant="body1">Are you sure you want to delete?</Typography>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setDeleteConfirmationOpen(false)}>Cancel</Button>
                    <Button onClick={handleDeleteConfirmation} color="secondary">
                        Delete
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog open={addCategoryModalOpen} onClose={() => setAddCategoryModalOpen(false)}>
                <DialogTitle>Add new Carrer Guide item</DialogTitle>
                <DialogContent className={classes.modalContent}>

                    {/* <div className="file-upload-img">
                                {image ? <img src={image} alt="upload" /> : <UploadFile />
                                {file? <div style={{color:'white'}}>file to upload: <span className='subtitle'>{file.name}</span> . </div>:null}
                                
                                <p>Maximum length 10mb</p>
                               
                                {
                                    !file?.name||!image ? <label htmlFor="contained-button-file">
                                    <input
                                        accept="application/image"
                                        style={{ display: 'none' }}
                                        id="contained-button-file"
                                        type="file"
                                        onChange={handleFileChange}
                                    />
                                    <Button variant="contained" component="span">
                                        Choose a image file
                                    </Button>
                                </label> : <Button onClick={()=>clearImage()} variant="contained" component="span">
                                        clear
                                    </Button>
                                }
                                
                            </div> */}



                    <TextField
                        label="item name"
                        value={newCategory.name}
                        onChange={(e) => setNewCategory({ ...newCategory, name: e.target.value })}
                    />
                    <TextField
                        label="item description"
                        value={newCategory.description}
                        onChange={(e) => setNewCategory({ ...newCategory, description: e.target.value })}
                    />



                    {/* <FormControl fullWidth>
                  <InputLabel htmlFor="empresa-select">Selecione a Empresa</InputLabel>
                  <Select
                    value={newCategoryEmpresa}
                    onChange={(e:any) => setNewCategoryEmpresa( e.target.value )}
                    inputProps={{
                      name: 'empresa',
                      id: 'empresa-select',
                    }}
                  >
                    {empresas.map((empresa: { _id: any; nome: any; }) => (
                      <MenuItem key={empresa._id} value={empresa._id}>
                        {empresa.nome}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <FormControl fullWidth>
                  <InputLabel htmlFor="permissao-select">Selecione o tipo de usuário</InputLabel>
                  <Select
                    value={newCategoryPermissoes}
                    onChange={(e:any) => setNewCategoryPermissoes( e.target.value )}
                    inputProps={{
                      name: 'permissao',
                      id: 'permissao-select',
                    }}
                  >
                    {permissoesList.map((permissao: any) => (
                      <MenuItem key={permissao} value={permissao}>
                        {permissao}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl> */}


                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setAddCategoryModalOpen(false)}>Cancelar</Button>
                    <Button onClick={handleAddCarrerguide} color="primary">
                        Create
                    </Button>
                </DialogActions>
            </Dialog>


            <Dialog open={uploadScreen} onClose={() => setUploadScreen(false)}>
                <DialogTitle>Edit company</DialogTitle>
                <DialogContent className={classes.modalContent}>

                    <div className="file-upload-img">
                        {image ? <img src={image} alt="upload" /> : <UploadFile />}
                        {/* <Avatar sx={{ width: 108, height: 108 }} style={{margin:'0 auto'}} alt={usuario.name} src={image||usuario.avatar} /> */}

                        {file ? <div style={{ color: 'white' }}>file to upload: <span className='subtitle'>{file.name}</span> . </div> : null}
                        {/* <h3> {file?.name || "Choose a pdf file"}</h3> */}
                        <p>Maximum length 10mb</p>
                        {/* <input type="file" onChange={handleFileChange} /> */}
                        {
                            !file?.name || !image ? <label htmlFor="contained-button-file">
                                <input
                                    accept="application/image"
                                    style={{ display: 'none' }}
                                    id="contained-button-file"
                                    type="file"
                                    onChange={handleFileChange}
                                />
                                <Button variant="contained" component="span">
                                    Choose a image file
                                </Button>
                            </label> : <Button onClick={() => clearImage()} variant="contained" component="span">
                                clear
                            </Button>
                        }

                    </div>



                    <TextField
                        label="Category name"
                        value={editData.name}
                        onChange={(e) => setEditData({ ...editData, name: e.target.value })}
                    />
                    <TextField
                        label="Category description"
                        value={newCategory.description}
                        onChange={(e) => setEditData({ ...editData, description: e.target.value })}
                    />



                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setUploadScreen(false)}>Cancelar</Button>
                    <Button onClick={handleUpdateCategory} color="primary">
                        Update
                    </Button>
                </DialogActions>
            </Dialog>
            {editCategoryModalOpen && editData.name ?
                <Dialog maxWidth="lg" open={editCategoryModalOpen} onClose={() => setEditCategoryModalOpen(false)}>
                    <DialogTitle>Edit company information</DialogTitle>
                    <DialogContent className={classes.modalContent}>
                        <TextField
                            label="Nome do usuário"
                            value={editData.name}
                            onChange={(e) => setEditData({ ...editData, name: e.target.value })}
                        />
                        <TextField
                            label="E-mail"
                            value={editData.email}
                            onChange={(e) => setEditData({ ...editData, email: e.target.value })}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <Email />
                                    </InputAdornment>
                                ),
                            }}
                            error={!validateEmail(editData.email)}
                            helperText={!validateEmail(editData.email) && 'E-mail inválido'}
                        />



                        {/* <FormControl fullWidth>
                  <InputLabel htmlFor="permissao-select">Selecione o tipo de usuário</InputLabel>
                  <Select
                    value={newCategoryPermissoes}
                    onChange={(e:any) => setNewCategoryPermissoes( e.target.value )}
                    inputProps={{
                      name: 'permissao',
                      id: 'permissao-select',
                    }}
                  >
                    {permissoesList.map((permissao: any) => (
                      <MenuItem key={permissao} value={permissao}>
                        {permissao}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl> */}



                        {/* <TextField
                  label="Empresa"
                  value={editData.empresa}
                  onChange={(e) => setNewCategoryEmpresa(e.target.value)}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <Business />
                      </InputAdornment>
                    ),
                  }}
                  error={editData.empresa == ""}
    
                  helperText={
                    editData.empresa=="" &&
                    'Empresa inválida'
                  }
                /> */}



                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => setEditCategoryModalOpen(false)}>Cancelar</Button>
                        <Button onClick={handleUpdateCategory} color="primary">
                            Atualizar
                        </Button>
                    </DialogActions>
                </Dialog> : null}


            {/* <Modal open={editCategoryModalOpen} onClose={() => setEditCategoryModalOpen(false)}>
      <div>
        <input
          type="text"
          value={editData.name}
          onChange={(e) => setEditData({ ...editData, nome: e.target.value })}
        />
        <input
          type="text"
          value={editData.email}
          onChange={(e) => setEditData({ ...editData, email: e.target.value })}
        />
        <input
          type="text"
          value={editData.telefone}
          onChange={(e) => setEditData({ ...editData, telefone: e.target.value })}
        />
        <input
          type="text"
          value={editData.cnpj}
          onChange={(e) => setEditData({ ...editData, cnpj: e.target.value })}
        />
        <button onClick={handleUpdateCategory}>Atualizar</button>
      </div>
    </Modal> */}
        </Container>
    );
};

const mapStateToProps = (state: any) => ({

    user: state.user.user



});

const mapDispatchToProps = {

};

const connector = connect(mapStateToProps, mapDispatchToProps);

export default connector(CarrerGuidePage);
